import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { setMeta } from "@/lib/usePageMeta";
import { COMPANY } from "@/legal/companyInfo";
import { ArrowLeft } from "lucide-react";

const LINKS = [
  { to: "/cgv", label: "CGV" },
  { to: "/confidentialite", label: "Confidentialité" },
  { to: "/registre-traitements", label: "Registre des traitements" },
  { to: "/mentions-legales", label: "Mentions légales" },
];

export default function LegalLayout({ title, subtitle, children }) {
  const loc = useLocation();
  useEffect(() => { setMeta(`${title} — Oresto`, subtitle); }, [title, subtitle]);
  return (
    <div className="min-h-screen bg-bg">
      <header className="max-w-3xl mx-auto px-6 pt-8 pb-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-brand-link">
          <div className="w-9 h-9 rounded-xl bg-primary-c flex items-center justify-center text-white font-display text-lg">O</div>
          <span className="font-display text-xl">Oresto</span>
        </Link>
        <Link to="/" className="text-sm text-text-secondary hover:text-[var(--text)] flex items-center gap-1" data-testid="legal-back-home">
          <ArrowLeft className="w-4 h-4" />
          Retour au site
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-8 page-enter">
        <h1 className="font-display text-4xl sm:text-5xl leading-tight">{title}</h1>
        {subtitle && <p className="mt-3 text-text-secondary text-lg">{subtitle}</p>}
        <div className="prose-oresto mt-8">{children}</div>
      </main>

      <footer className="border-t border-c mt-16">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`${loc.pathname === l.to ? "text-primary-c font-semibold" : "text-text-secondary hover:text-[var(--text)]"}`}
                data-testid={`legal-footer-${l.to.slice(1)}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <p className="text-xs text-text-secondary mt-4">© 2026 {COMPANY.publisherLine}</p>
        </div>
      </footer>
    </div>
  );
}
